export default "__VITE_ASSET__gDxfDly$__"